var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 12.0005C8.75 10.7579 9.75736 9.7505 11 9.7505C12.2426 9.7505 13.25 10.7579 13.25 12.0005C13.25 13.2431 12.2426 14.2505 11 14.2505C9.75736 14.2505 8.75 13.2431 8.75 12.0005Z",
    fill: "#525252"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.58523 3.23279C8.56564 -0.202595 13.4342 -0.202596 14.4147 3.23279C14.7184 4.29719 15.812 4.92855 16.8857 4.65942C20.351 3.79079 22.7853 8.00712 20.3004 10.5739C19.5305 11.3691 19.5305 12.6319 20.3004 13.4271C22.7853 15.9939 20.351 20.2102 16.8857 19.3416C15.812 19.0725 14.7184 19.7038 14.4147 20.7682C13.4342 24.2036 8.56564 24.2036 7.58523 20.7682C7.28146 19.7038 6.18792 19.0725 5.11423 19.3416C1.6489 20.2102 -0.785401 15.9939 1.69952 13.4271C2.46944 12.6319 2.46944 11.3691 1.69952 10.5739C-0.785401 8.00712 1.6489 3.79079 5.11423 4.65942C6.18792 4.92855 7.28146 4.29719 7.58523 3.23279ZM11 8.2505C8.92893 8.2505 7.25 9.92944 7.25 12.0005C7.25 14.0716 8.92893 15.7505 11 15.7505C13.0711 15.7505 14.75 14.0716 14.75 12.0005C14.75 9.92944 13.0711 8.2505 11 8.2505Z",
    fill: "#525252"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.1cb4c6b67117ddd869c3cabcc850d719.svg";
export { ForwardRef as ReactComponent };